__turbopack_context__.v({
  "cell": "_096Ya_cell",
  "container": "_096Ya_container",
  "controls": "_096Ya_controls",
  "heading": "_096Ya_heading",
  "input": "_096Ya_input",
  "label": "_096Ya_label",
  "link": "_096Ya_link",
  "scrollContainer": "_096Ya_scrollContainer",
  "table": "_096Ya_table",
  "variant--tags": "_096Ya_variant--tags",
});
